/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

// src/components/software/SoftwareSubnav.jsx

import React from "react";

const SoftwareSubnav = ({
  active = "overview",
}) => {

  // const items = [
  //
  //   {
  //     key: "overview",
  //     label: "Overview",
  //     href: "/software/",
  //     icon: "dashboard",
  //   },
  //
  //   {
  //     key: "edge",
  //     label: "Orion Edge",
  //     href: "/software/orion-edge/",
  //     icon: "phone_iphone",
  //   },
  //
  //   {
  //     key: "mobile",
  //     label: "Orion Mobile",
  //     href: "/software/orion-mobile/",
  //     icon: "devices",
  //   },
  //
  //   {
  //     key: "downloads",
  //     label: "Downloads",
  //     href: "/software/downloads/",
  //     icon: "download",
  //   },
  //
  //   {
  //     key: "roadmap",
  //     label: "Roadmap",
  //     href: "/software/roadmap/",
  //     icon: "timeline",
  //   },
  //
  // ];

  const items = [
  {
    key: "overview",
    label: "Overview",
    href: "#overview",
    icon: "dashboard",
  },

  {
    key: "products",
    label: "Products",
    href: "#products",
    icon: "apps",
  },

  {
    key: "roadmap",
    label: "Roadmap",
    href: "#roadmap",
    icon: "timeline",
  },
];

  return (

    <div
      className="
        fixed
        top-[150px]
        left-1/2
        -translate-x-1/2
        z-40
        hidden
        lg:flex
      "
    >

      <div
        className="
          flex
          items-center
          gap-2

          bg-white/15
          backdrop-blur-xl

          border
          border-white/40

          shadow-[0_8px_32px_rgba(0,0,0,0.10)]

          rounded-2xl

          px-3
          py-3
        "
      >

        {items.map((item) => (

          <a
            key={item.key}
            href={item.href}
            className={`
              flex
              items-center
              gap-2

              px-4
              py-3

              rounded-xl

              text-sm
              font-semibold

              transition-all
              duration-200

              ${
                active === item.key
                  ? `
                    bg-blue-700
                    text-white
                    shadow-md
                  `
                  : `
                    text-gray-700
                    hover:bg-blue-50
                    hover:text-blue-700
                  `
              }
            `}
          >

            <span
              className="
                material-symbols-outlined
                text-[18px]
              "
            >
              {item.icon}
            </span>

            {item.label}

          </a>

        ))}

      </div>

    </div>

  );
};

export default SoftwareSubnav;